export const parseYearFromUseApproveDate = (value) => {
  const year = Number(String(value || '').slice(0, 4).replace(/\D/g, ''));
  return Number.isFinite(year) ? year : null;
};

export const parseAreaCandidatesM2 = (planTypeName) => {
  const source = String(planTypeName || '');
  if (!source.trim()) return [];
  const candidates = [];
  const unitRegex = /(\d+(?:\.\d+)?)\s*(m2|m²|㎡|평)/gi;
  let match = unitRegex.exec(source);
  while (match) {
    const num = Number(match[1]);
    const unitToken = String(match[2] || '').toLowerCase();
    if (Number.isFinite(num) && num > 0) candidates.push(unitToken.includes('평') ? num * 3.305785 : num);
    match = unitRegex.exec(source);
  }
  if (candidates.length > 0) return candidates;
  const plainRegex = /(\d+(?:\.\d+)?)/g;
  let plain = plainRegex.exec(source);
  while (plain) {
    const num = Number(plain[1]);
    if (Number.isFinite(num) && num > 0) candidates.push(num);
    plain = plainRegex.exec(source);
  }
  return candidates;
};
